import { createContext } from 'react';
import type { SupportedLanguage } from '../../api/generated/client';
import type { IWealthNavigatorMicroFrontendProps } from '../../interfaces/wealth-navigator';

export interface IYwuAppContextValues extends IWealthNavigatorMicroFrontendProps {
    isPresentationMode: boolean;
    setPresentationMode: (isPresentationModeOn: boolean) => void;
    activeDomicile: string;
    setActiveDomicile: (isoAlpha2: string) => void;
    activeLanguage: SupportedLanguage;
    setActiveLanguage: (isoAlpha2: SupportedLanguage) => void;
}

export const ywuAppContext = createContext<IYwuAppContextValues | null>(null);
